module.exports = __webpack_public_path__ + "img/icon-fail.2a658e81.png";